module.exports = __webpack_public_path__ + "img/harry-hall-logo.71623f75.png";